<template>
    <div class="Ajapp" :style="{ '--divWidth--': divWidth, '--divHeight--': divHeight, }" style="width: var(--divWidth--);height: var(--divHeight--);top: 0;left: 0;z-index: 1 !important;
background-repeat:no-repeat;background-size: var(--divWidth--)  var(--divHeight--);overflow: hidden;">
        <div style="width: 85%;height: 80%;margin: 8% auto 2%;overflow: hidden;">
            <div ref="eCharts" style="width: 100%;height: 100%;overflow: hidden;"></div>
        </div>
        <div class="admin" style="position: fixed;top: 2%;width: 15%;" :style="{ 'right': '-' + nowSize(190) + 'px', }">
            <el-button round style="background-color: rgba(11, 2, 2, 0.5);"
                :style="{ 'marginLeft': nowSize(60) + 'px', }" @click="goToAdmin">活动管理</el-button>
        </div>
        <div class="admin" style="position: fixed;top: 7%;width: 15%;" :style="{ 'right': '-' + nowSize(190) + 'px', }">
            <el-button round style="background-color: rgba(11, 2, 2, 0.5);"
                :style="{ 'marginLeft': nowSize(60) + 'px', }" @click="goToSet">设置</el-button>
        </div>
        <div style="position: fixed;top: 30%;width: 16%;right: 1%;">
            <el-image :src="viteImg" ></el-image>
        </div>
    </div>
</template>
<script>
import echarts from "echarts";
import request from "../../../request";
import {
    getPzVoteRecordRankUser,
} from "../../api/api";
export default {
    name: 'HomePage',
    components: {

    },
    data() {
        return {
            viteImg:require('../../assets/img/vote.png'),
            pvmId: '',
            colorArr: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#e03997', '#f37b1d', '#8dc63f', '#39b54a', '#0081ff', '#6739b6', '#9c26b0', '#a5673f'],
            dataValue: [],
            echartsStr: [],
            dataName: [],
            datalength: 3,
            bg: require('../../assets/img/1.gif'),
            divWidth: '100%',
            divHeight: '100%',
        }
    },
    computed: {

    },
    watch: {
        divWidth(n, v) {
            setTimeout(() => {
                this.echartsStr.resize();
            }, 300)
        }
    },
    activated() {

    },
    mounted() {
        const _this = this;
        window.addEventListener("resize", function () {
            _this.echartsStr.resize();
        })
    },
    created() {
        document.title = '投票排行榜';
        console.log(this.$route.query.pvmId)
        this.pvmId = this.$route.query.pvmId
        if (this.$route.query.pvmId) {
            getPzVoteRecordRankUser({ pvmId: this.$route.query.pvmId }).then(res => {
                this.valueData = res.data;
                res.data.forEach((items, index) => {
                    if (index <= this.datalength - 1) {
                        this.dataName.push(items.name);
                        const s = {
                            value: items.value,
                            itemStyle: {
                                color: this.colorArr[index]
                            }
                        }
                        this.dataValue.push(s);
                    }
                })
                this.DrawEcharts()
            })
        }
        var timer = setInterval(() => {
            setTimeout(() => {
                ///调取接口
                this.dataValue = [],
                    this.dataName = [],
                    getPzVoteRecordRankUser({ pvmId: this.pvmId }).then(res => {
                        this.valueData = res.data;
                        res.data.forEach((items, index) => {
                            if (index <= this.datalength - 1) {
                                this.dataName.push(items.name);
                                const s = {
                                    value: items.value,
                                    itemStyle: {
                                        color: this.colorArr[index]
                                    }
                                }
                                this.dataValue.push(s);
                            }
                        })
                        this.DrawEcharts();
                    })
            }, 0);
        }, 30000);

    },
    methods: {
        getList() {
            this.dataValue = [],
                this.dataName = [],
                getPzVoteRecordRankUser({ pvmId: this.pvmId }).then(res => {
                    this.valueData = res.data;
                    res.data.forEach((items, index) => {
                        if (index <= this.datalength - 1) {
                            this.dataName.push(items.name);
                            const s = {
                                value: items.value,
                                itemStyle: {
                                    color: this.colorArr[index]
                                }
                            }
                            this.dataValue.push(s);
                        }
                    })
                    this.DrawEcharts();
                })
        },
        goToSet() {
            this.$prompt('请输入展示多少个投票项', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                if (value > this.valueData.length) {
                    this.$message({
                        type: 'danger',
                        message: '暂时没有这么多投票项'
                    });
                } else {
                    this.datalength = value;
                    this.getList();
                }

            }).catch(() => {

            });
        },
        // 返回活动管理
        goToAdmin() {
            this.$router.replace('/Home')
        },
        // 图标配置项
        DrawEcharts() {
            this.echartsStr = this.$echarts.init(this.$refs.eCharts);
            this.echartsStr.setOption({
                grid: {
                    bottom: '1%',
                    // top: '15%',     // 距离顶部的距离
                },
                xAxis: {
                    type: 'category',
                    data: this.dataName,
                    show: false, // 隐藏Y轴
                    axisLabel: {
                        textStyle: {
                            color: '#6739b6', // 设置文本颜色为红色
                            fontSize: this.nowSize(30),

                        },
                        formatter: function (value) {
                            var ret = ''
                            var maxLength = 7
                            var valLength = value.length
                            var rowN = Math.ceil(valLength / maxLength)
                            if (rowN > 1) {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = ''
                                    var start = i * maxLength
                                    var end = start + maxLength
                                    temp = value.substring(start, end) + '\n'
                                    ret += temp
                                }
                                return ret

                            } else {

                                return value

                            }

                        }
                    }
                },
                yAxis: {
                    show: false // 隐藏Y轴
                },
                series: [
                    {
                        data: this.dataValue,
                        type: 'bar',
                        label: {
                            show: true, // 显示值
                            position: 'inside', // 在顶部显示
                            formatter: '{c}\n{b}',
                            formatter: function (params) {
                                var ret = ''
                                var maxLength = 10
                                var valLength = params.name.length
                                var rowN = Math.ceil(valLength / maxLength)
                                if (rowN > 1) {
                                    for (var i = 0; i < rowN; i++) {
                                        var temp = ''
                                        var start = i * maxLength
                                        var end = start + maxLength
                                        temp = params.name.substring(start, end) + '\n'
                                        ret += temp
                                    }
                                    return params.value +'\n'+ ret

                                } else {

                                    return params.value +'\n'+ params.name

                                }

                            },
                            textStyle: {
                                color: '#FDFDFF', // 设置文本颜色为红色
                                fontSize: this.nowSize(30),
                                fontWeight: 800,
                            }, //格式化显示，{c} 代表数据值，{b} 代表 x 轴名称
                        }
                    }
                ]
            })
        },
        //  换算方法
        nowSize(val, initWidth = 1920) {
            //当前视口宽度
            let nowClientWidth = document.documentElement.clientWidth;
            return val * (nowClientWidth / initWidth);
        }
    }
}
</script>

<style scoped>
.diaZj::-webkit-scrollbar {
    display: none;
}

.admin:hover {
    right: 1% !important;
    width: auto !important;
}

.diaBg {
    background-image: url(../../assets/img/bg3.jpg) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.diaBg2 {
    background-image: url(../../assets/img/mingdanBg.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.Ajapp {
    background-image: url(../../assets/img/bg33.jpg) !important;
}

.ajMain {
    display: flex;
    height: 80%;
    width: 90%;
    justify-content: space-between;
    margin: 8% auto;
    overflow: hidden;
}

.leftDiv {
    width: 25%;
    background-image: url(../../assets/img/left.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.centenDiv {
    width: 75%;
    background-image: url(../../assets/img/mingdanBg.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.rightDiv {
    width: 18%;
    margin-left: 2%;
    background-image: url(../../assets/img/right.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100%;
}

.handImg {
    background-image: url(../../assets/img/hand.png) !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
}

.handImgto {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    width: 100%;
    height: 100%;
    background: url(../../assets/img/headquan.png) no-repeat !important;
    background-size: 100% 100% !important;
    -webkit-animation: rotateAnimation 2.5s infinite linear;
    animation: rotateAnimation 2.5s infinite linear;
    transform-origin: center !important;
}

@keyframes rotateAnimation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }


}
</style>
